<template>
  <Layout :containers="containers">
    <template v-slot:header>
      <DefaultHeroBar
        :hasQuickStartCallout="false"
        :section="'adviserResourcesHeader'"
      />
    </template>

    <template v-slot:intro>
      <AdviserEnrolmentIntro
        :heading="intro.heading"
        :lead="intro.lead"
        leadWeight="regular"
        :paragraphs="[]"
        flush
      />
      <HR narrow />
    </template>

    <template v-slot:brochures>
      <section class="adviser-section">
        <AdviserSectionHeading
          :title="brochures.heading"
          :subtitle="brochures.subtitle"
        />
        <AdviserBenefitCardGrid class="grid" :cards="brochures.cards" />
      </section>
      <HR narrow />
    </template>

    <template v-slot:videos>
      <section class="adviser-section">
        <AdviserSectionHeading
          :title="videos.heading"
          :subtitle="videos.subtitle"
        />
        <AdviserVideoGrid class="grid" :videos="videoTiles" />
      </section>
    </template>

    <template v-slot:channelCta>
      <AdviserChannelSelector
        :heading="channelCta.heading"
        :headingLight="channelCta.headingLight"
        :subtitle="channelCta.subtitle"
        showAllChannels
      />
    </template>

    <template v-slot:linkCards>
      <section class="adviser-section link-cards">
        <AdviserBenefitCardGrid :cards="linkCards" />
      </section>
    </template>
  </Layout>
</template>

<script>
  import {
    RESOURCES_INTRO,
    RESOURCES_BROCHURES,
    RESOURCES_VIDEOS,
    RESOURCES_CHANNEL_CTA,
    RESOURCES_LINK_CARDS,
  } from '@/constants/adviser-enrolment/resources-content';
  import Layout from '../../common/layouts/Layout.vue';
  import DefaultHeroBar from '../../common/DefaultHeroBar.vue';
  import HR from '../../common/HR.vue';
  import AdviserEnrolmentIntro from './AdviserEnrolmentIntro.vue';
  import AdviserSectionHeading from './AdviserSectionHeading.vue';
  import AdviserBenefitCardGrid from './AdviserBenefitCardGrid.vue';
  import AdviserVideoGrid from './AdviserVideoGrid.vue';
  import AdviserChannelSelector from './AdviserChannelSelector.vue';

  export default {
    name: 'AdviserResources',
    components: {
      Layout,
      DefaultHeroBar,
      HR,
      AdviserEnrolmentIntro,
      AdviserSectionHeading,
      AdviserBenefitCardGrid,
      AdviserVideoGrid,
      AdviserChannelSelector,
    },
    metaInfo: {
      meta: [
        {
          name: 'robots',
          content: 'nofollow',
        },
        {
          name: 'robots',
          content: 'noindex',
        },
      ],
    },
    data() {
      return {
        intro: RESOURCES_INTRO,
        brochures: RESOURCES_BROCHURES,
        videos: RESOURCES_VIDEOS,
        channelCta: RESOURCES_CHANNEL_CTA,
        linkCards: RESOURCES_LINK_CARDS,
      };
    },
    computed: {
      // Embed URLs live in whitelabel.videos so marketing's real links are a
      // config change.
      videoTiles() {
        return this.videos.items.map(item => ({
          title: item.title,
          description: item.description,
          source: this.whitelabel.videos[item.videoKey] || '',
        }));
      },
      containers() {
        return [
          {
            name: 'header',
            background: 'countryPattern',
            class: 'hero-banner',
          },
          {
            name: 'intro',
            background: 'countryPattern',
            fadedRow: true,
          },
          { name: 'brochures' },
          { name: 'videos' },
          { name: 'channelCta' },
          { name: 'linkCards' },
        ];
      },
    },
  };
</script>

<style scoped lang="scss">
  @import '../../../constants/styles/adviser-pages.scss';

  .adviser-section {
    @include adviser-content-column;
    margin-top: $adviser-section-gap;

    .grid {
      margin-top: 60px;
    }
    &.link-cards {
      padding-bottom: $adviser-footer-gap;
    }
  }

  ::v-deep .channel-selector-wrapper {
    margin-top: $adviser-section-gap;
  }
</style>
